import React, { useEffect, useState, useRef } from 'react';
import {
    Box,
    Button,
    Heading,
    HStack,
    useToast,
    Badge,
    Text,
    VStack,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Flex
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import ResultControllingTktDetails from './ResultControllingTktDetails';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";


const ResultControlling = () => {
    const [loading, sloading, error] = useState(false, false, null);
    const [status, setStatus] = useState("Disconnected from server."); // Connection status
    const [statusColor, setStatusColor] = useState("red"); // Status text color
    const [isConnected, setIsConnected] = useState(true); // WebSocket connection state
    const socketRef = useRef(null); // Stores WebSocket instance persistently
    const [startLoading, setLoading] = useState(false);


    const [scoreboard, setScoreboard] = useState({
        has_change_b: false,
        next_draws: [],
        pending_result: []
    });

    const location = useLocation();
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const tabIndex = queryParams.get('tab');

    // State to control the selected tab
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);


    useEffect(() => {
        console.log("Tab  ", queryParams.get('tab'));
        if (tabIndex === '1') {
            setSelectedTabIndex(0); // Select the first tab (Result DS)
        } else if (tabIndex === '2') {
            setSelectedTabIndex(1); // Select the second tab (Ticket DS)
        }
    }, [tabIndex]);

    useEffect(() => {

        if (!socketRef.current) {
            console.log("use effect is connected")
            socketRef.current = new WebSocket('ws://localhost:5003/ws/scoreboard');
            socketRef.current.onopen = () => {
                setIsConnected("true");
                on_open();
            }
            socketRef.current.onmessage = (event) => {
                //   console.log("Received:", event.data);
                //  console.log('onmessage');
                onmessage(event);
            }//(event) => console.log('Message:', event.data);
            socketRef.current.onclose = () => {
                console.log('WebSocket Disconnected');
                disconnectWebSocket();
            }
        }



        return () => {
            if (socketRef.current) {
                 console.log('WebSocket status',isConnected);
                if (isConnected) {
                    socketRef.current.close(); // Close WebSocket on unmount
                    socketRef.current = null;
                }
                // socketRef.current.close(); // Close WebSocket on unmount

            }
        };


    }, []);


    const connectWebSocket = () => {
        console.log('connectWebSocket button pressed', isConnected);
        if (socketRef.current) {
            //  socket = new WebSocket('ws://localhost:5003/ws/scoreboard');


        } else {
            console.log('disconnectWebSocket button pressed');
            disconnectWebSocket();
        }

    };
    const on_open = () => {
        setIsConnected("true");
        console.log('WebSocket Connected .... to ds', isConnected);
        setStatus("Connected to server.");
        setStatusColor("green");

    }

    const onmessage = (event) => {
        try {
            console.log('WebSocket on message .... to ds', isConnected);
            if (isConnected) {
                console.log('WebSocket on message ', isConnected);
                const data = JSON.parse(event.data);
                console.log("Parsed data:", data);
                setScoreboard(data); // Update state with parsed data
            } else {
                console.log("isConnected data:", isConnected);
                disconnectWebSocket()
            }

        } catch (error) {
            console.error("Failed to parse JSON:", error);
        }

    };

    const disconnectWebSocket = () => {
        if (socketRef.current) {
            //setIsConnected("false");
            socketRef.current.close();
            socketRef.current = null;
            console.log('Disconnected from server.');
            setStatus("Disconnected from server.");
            setStatusColor("red");
            setScoreboard([]);


        }
    };

    const startDS = async () => {
        setLoading(true);
        try {
            const base_url = process.env.REACT_APP_DS_BASE_URL;
            const response = await fetch(`${base_url}start`, {
                method: "GET",

            }); // Replace with your actual API URL
            if (!response.ok) throw new Error("Failed to start DS");
            else if (response.ok) {
                setStatus(status + " Draw Started");
            }
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const stopDS = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_DS_BASE_URL}stop`, {
                method: "GET",
            });
            if (!response.ok) throw new Error("Failed to stop DS");
            else if (response.ok) {
                setStatus(status + " Draw Ended");
            }

        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleCellClick = (value) => {
        console.log("draw_id ", value.DrawID);
        console.log("value ", value.GameNumber)
        // Update the query string with the new value for the clicked cell
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('gID', `${value.GameNumber}`);
        searchParams.set('dID', `${value.DrawID}`);
        // Update the query parameter with the new value
        navigate({ search: searchParams.toString() }, { replace: true }); // Update URL without refreshing
    };
    
    const ds_uploadGame = async()=>{
        //"/api/ds/game-upload"
        try {
            const response = await axios.GET("/api/ds/game-upload");
            console.log("Upload successful:", response.data);
          } catch (error) {
            console.error("Upload failed:", error);
          }
    }

    const createTableFromJson = (data, linkID) => {
        if (!data || data.length === 0) return null;

        const columns = Object.keys(data[0]);
        return (
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col}
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    textAlign: "left",
                                }}
                            >
                                {col}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}
                            style={{ border: "1px solid #ccc", padding: "8px", cursor: 'pointer' }}
                            onClick={() => handleCellClick(row)} >
                            {columns.map((col) => (
                                <td
                                    key={col}
                                    style={{ border: "1px solid #ccc", padding: "8px" }}

                                >
                                    {row[col]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };


    if (loading && sloading) return <Box>Loading...</Box>;
    if (error) return <Box>Error: {error}</Box>;
    return (
        <Box p={5}>
            <VStack spacing={5} align="stretch">
                <Box>
                    <Heading size="lg" mb={4}>Result Control Management</Heading>
                    <HStack spacing={4} mb={4}>

                    </HStack>
                </Box>
                <Tabs value={selectedTabIndex} onValueChange={(index) => setSelectedTabIndex(index)}>
                    <TabList>
                        <Tab>Result DS</Tab>
                        <Tab>Ticket DS</Tab>
                        <Tab>Pending Result</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            <Button colorScheme={isConnected ? "orange" : 'yellow'} onClick={connectWebSocket} disabled={isConnected}>{isConnected ? 'Disonnect' : 'Connect'}</Button>
                            <br />
                            <Button colorScheme={isConnected ? "green" : 'red'} onClick={startDS} disabled={isConnected}>Start DS</Button>
                            <Button colorScheme="red" onClick={stopDS} disabled={!isConnected}>Stop DS</Button>
                            <Button colorScheme='blue' onClick={ds_uploadGame} >DS Upload Game</Button>
                            <p style={{ color: statusColor }}>{status}</p>
                            <div id='scoreboard'>
                                <div className="section">
                                    <h3>Next Draws</h3>

                                    {
                                        scoreboard != undefined ? (
                                            scoreboard.has_change_b ? (
                                                scoreboard.next_draws ? (
                                                    createTableFromJson(scoreboard.next_draws, true)
                                                ) : (
                                                    <p>No draws available.</p>
                                                )
                                            ) : (
                                                <pre>Loading...</pre>
                                            )) : (
                                            <p>No scoreboard {scoreboard}</p>
                                        )}
                                </div>
                                <div className="section">
                                    <h3>Pending result Draws - ({scoreboard?.pending_result?.length || 0})</h3>
                                    {
                                        scoreboard != undefined ? (
                                            scoreboard.has_change_c ? (
                                                scoreboard.pending_result ? (
                                                    createTableFromJson(scoreboard.pending_result, false)
                                                ) : (
                                                    <p>No draws available.</p>
                                                )
                                            ) : (
                                                <pre>Loading...</pre>
                                            )) : (
                                            <p>No scoreboard</p>
                                        )}
                                </div>
                            </div>

                        </TabPanel>
                        <TabPanel>
                            <ResultControllingTktDetails />
                        </TabPanel>
                        <TabPanel>
                            Pending
                        </TabPanel>
                    </TabPanels>
                </Tabs>

            </VStack>
        </Box>
    )

};


export default ResultControlling;